module.exports = __webpack_public_path__ + "static/img/banner.01cdd49b.png";